__turbopack_context__.v({
  "wrapper": "recommended-products-element-module-scss-module__6Pgwea__wrapper",
  "wrapper--compact": "recommended-products-element-module-scss-module__6Pgwea__wrapper--compact",
});
